import React from "react";

// importando o swiper
import { Swiper, SwiperSlide } from "swiper/react";

// importando os estilos do swiper
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../swiper.css";

// modulos necessários do swiper
import { Pagination, Navigation, Autoplay } from "swiper";

// importando dados
import { about } from "../data";

const About = () => {
  return (
    <>
      <h1 className="text-orange text-5xl md:text-7xl sm:text-3xl text-center mt-20 font-bold p-4">
        O que mais o Inclusive Pet oferece?
      </h1>

      <Swiper
        modules={[Pagination, Navigation, Autoplay]}
        autoplay={true}
        loop={true}
        navigation={true}
        className="heroSlider"
      >
        {about.map((slide, index) => {
          const { title, subtitle, image } = slide;
          return (
            <SwiperSlide key={index} className="py-10 lg:py-5">
              <div className="container mx-auto text-center lg:text-left">
                <div className="w-full flex flex-col justify-between items-center lg:flex-row">
                  <div className="flex-1">
                    <h1 className="text-center text-orange text-[35px] leading-tight lg:text-[50px] lg:leading-[98px] font-extrabold mb-4">
                      {title}
                    </h1>
                    <p className="text-justify text-base lg:text-[15px] lg:leading-8 max-w-[540px] mb-8">
                      {subtitle}
                    </p>
                  </div>

                  <div className="flex flex-1 justify-center w-[250px] h-[600px] items-center">
                    <img
                      src={image.type}
                      alt="Dog"
                      className="lg:w-[375px] lg:h-[375px] mb-10"
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </>
  );
};

export default About;
